import { render, staticRenderFns } from "./editClientDetail.vue?vue&type=template&id=c7422740&scoped=true&"
import script from "./editClientDetail.vue?vue&type=script&lang=js&"
export * from "./editClientDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7422740",
  null
  
)

export default component.exports